// extracted by mini-css-extract-plugin
export default {"container":"EditorFormattingMenuControl_container__pvSeo","tooltip":"EditorFormattingMenuControl_tooltip__dImNp"};